import type { Vec3 } from "../math/vec3.js";
import type { GlassPaneDef, MapBox, MapDef } from "./types.js";

/**
 * Window panes as collision. A pane is a solid until it breaks, so it lives at
 * a KNOWN index in the collision world: the hard solids first, the panes after,
 * in `map.glass` order. `RayHit.boxIndex >= glassBoxBase(map)` therefore means
 * pane `boxIndex - base`, and breaking one is `setSolidEnabled(index, false)`.
 */

/** Collision index of pane 0 — one past the last hard solid. */
export function glassBoxBase(map: MapDef): number {
  return map.solids.length;
}

/**
 * The solid array both server and client must hand to `stepProjectile`, and
 * the one `buildMapCollisionWorld` builds from: `map.solids` then one box per
 * pane, so every index agrees.
 */
export function mapCollisionSolids(map: MapDef): MapBox[] {
  const out: MapBox[] = map.solids.slice();
  for (const g of map.glass ?? []) out.push({ box: g.box, material: "glass" });
  return out;
}

export function glassPaneCenter(pane: GlassPaneDef): Vec3 {
  const b = pane.box;
  return {
    x: (b.min.x + b.max.x) * 0.5,
    y: (b.min.y + b.max.y) * 0.5,
    z: (b.min.z + b.max.z) * 0.5,
  };
}

/** Which horizontal axis the pane's normal runs along — its thinner extent. */
export function glassPaneNormalAxis(pane: GlassPaneDef): "x" | "z" {
  const b = pane.box;
  return b.max.x - b.min.x <= b.max.z - b.min.z ? "x" : "z";
}
